<template>
  <div class="withdrawal">
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane label="提现记录" name="record">
        <div>
          <el-form :model="recordQuery" label-width="90px" inline size="mini">
            <el-form-item label="用户类型">
              <el-select v-model="recordQuery.sourceType" clearable placeholder="请选择用户状态">
                <el-option label="代理" value="11"></el-option>
                <el-option label="员工" value="12"></el-option>
                <el-option label="商家" value="21"></el-option>
                <el-option label="合伙人" value="22"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="手机号码">
              <el-input v-model="recordQuery.cellphone" clearable placeholder="请输入手机号码"></el-input>
            </el-form-item>
            <el-form-item label="账号类型">
              <el-select v-model="recordQuery.accountType" clearable placeholder="请选择账号类型">
                <el-option label="连连" value="1111"></el-option>
                <el-option label="支付宝" value="0000"></el-option>
                <el-option label="微信" value="9999"></el-option>
                <el-option label="数信泽对私" value="5555"></el-option>
                <el-option label="数信泽对公" value="6666"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="提现状态">
              <el-select v-model="recordQuery.status" clearable placeholder="请选择提现状态">
                <el-option label="申请中" value="0"></el-option>
                <el-option label="提现成功" value="1"></el-option>
                <el-option label="提现失败" value="2"></el-option>
                <el-option label="暂缓打款" value="3"></el-option>
                <el-option label="提现回退" value="4"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="提现流水号">
              <el-input v-model="recordQuery.keyword" clearable placeholder="请输入提现流水号"></el-input>
            </el-form-item>
            <el-form-item label="提现时间段">
              <el-date-picker
                v-model="period"
                type="daterange"
                align="right"
                value-format="yyyy-MM-dd"
                unlink-panels
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
              ></el-date-picker>
            </el-form-item>
            <el-button type="primary" size="mini" @click="seach">搜索</el-button>
            <el-button type="success" @click="downloadExcel" size="mini">导出数据</el-button>
          </el-form>
          <el-card>
            <el-table :data="withdrawalList" style="width: 100%" height="650px" border="" stripe>
              <!-- <el-table-column type="index"></el-table-column> -->
              <el-table-column type="expand">
                <template slot-scope="scope">
                  <el-form label-position="left" inline class="demo-table-expand">
                    <el-form-item label="提现账号 :">
                      <span>{{scope.row.accountNo}}</span>
                    </el-form-item>
                    <el-form-item label="提现备注 :">
                      <span>{{scope.row.remark}}</span>
                    </el-form-item>
                  </el-form>
                </template>
              </el-table-column>
              <el-table-column prop="uuid" label="流水号" width="240"></el-table-column>
              <el-table-column prop="amount" label="提现金额(元)" width="120" align="right"></el-table-column>
              <el-table-column prop="currentUnusedAmount" label="当前余额(元)" width="120" align="right"></el-table-column>
              <el-table-column prop="serviceChargesFee" label="手续费(元)" width="120" align="right"></el-table-column>
              <el-table-column label="提现状态" width="100">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.status === 0">申请中</el-tag>
                  <el-tag v-else-if="scope.row.status === 1" type="success">提现成功</el-tag>
                  <el-tag v-else-if="scope.row.status === 2" type="warning">提现失败</el-tag>
                  <el-tag v-else-if="scope.row.status === 3" type="danger">暂缓打款</el-tag>
                  <el-tag v-else-if="scope.row.status === 4" type="info">提现回退</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="accountType" label="提现渠道">
                <template slot-scope="scope">
                  <span v-if="scope.row.accountType === '0000'">支付宝</span>
                  <span v-else-if="scope.row.accountType === '9999'" type="success">微信</span>
                  <span v-else-if="scope.row.accountType === '8888'" type="success">货款抵扣</span>
                  <span v-else-if="scope.row.accountType === '5555'" type="success">数信泽对私</span>
                  <span v-else-if="scope.row.accountType === '6666'" type="success">数信泽对公</span>
                  <span v-else-if="scope.row.accountType === '1111'" type="success">连连</span>
                </template>
              </el-table-column>
              <el-table-column v-if="recordQuery.sourceType === '21'" key="name" prop="name" label="店名"></el-table-column>
              <el-table-column prop="accountName" label="提现姓名"></el-table-column>
              <el-table-column prop="cellphone" label="联系手机" width="120"></el-table-column>
              <el-table-column prop="createTime" label="提现时间" width="150"></el-table-column>
              <el-table-column prop="finishTime" label="到账时间" width="150"></el-table-column>
              <el-table-column label="操作" width="90">
                <template slot-scope="scope">
                  <el-button
                    :disabled="!((scope.row.status === 0) || (scope.row.status === 3) ||
                     (scope.row.status === 2 && (scope.row.accountType === '5555' || scope.row.accountType === '6666') && !scope.row.remark.includes('已退')))"
                    type="success"
                    size="small"
                    @click="editWithdraw(scope.row.uuid, scope.row.remark)"
                  >处理</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              @size-change="recordPageSizeChange"
              @current-change="recordCurrentPageChange"
              :current-page="recordQuery.curPage"
              :page-sizes="[5, 10, 15]"
              :page-size="recordQuery.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="recordTotal"
            ></el-pagination>
          </el-card>
        </div>
      </el-tab-pane>
      <el-tab-pane label="提现规则" name="rule">
        <div>
          <el-form inline size="mini">
            <el-button type="danger" size="mini" @click="setRuleDialogVisible = true">新增提现规则</el-button>
          </el-form>
          <el-card>
            <!-- 表格数据展示区域 -->
            <el-table :data="ruleList" style="width: 100%; height: 650px;" border="" stripe>
              <el-table-column type="index"></el-table-column>
              <el-table-column prop="minAmount" label="单笔最低(元)"></el-table-column>
              <el-table-column prop="maxAmount" label="单笔最高(元)"></el-table-column>
              <el-table-column prop="totalAmount" label="当日最高(元)"></el-table-column>
              <el-table-column prop="serviceFeeRate" label="单笔手续费(%)"></el-table-column>
              <el-table-column prop="serviceFeeUnit" label="单笔手续费(元)"></el-table-column>
              <el-table-column label="单笔手续费类型">
                <template slot-scope="scope">
                  <span v-if="scope.row.serviceFeeType === 1">百分比</span>
                  <span v-if="scope.row.serviceFeeType === 2">单笔</span>
                  <span v-if="scope.row.serviceFeeType === 3">百分比 + 单笔</span>
                </template>
              </el-table-column>
              <el-table-column prop="createTime" label="创建时间"></el-table-column>
            </el-table>
            <!-- 分页区域 -->
            <el-pagination
              @size-change="rulePageSizeChange"
              @current-change="ruleCurrentPageChange"
              :current-page="ruleQuery.curPage"
              :page-sizes="[5, 10, 15]"
              :page-size="ruleQuery.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="ruleTotal"
            ></el-pagination>
          </el-card>
        </div>
      </el-tab-pane>
    </el-tabs>
    <!-- 处理提现对话框 -->
    <el-dialog title="处理提现" :visible.sync="editDialogVisible" width="35%">
      <el-form :model="withdrawForm" label-width="80px">
        <el-form-item label="到账方式: ">
          <el-select v-model="withdrawForm.state" size="small" placeholder="请选择到账方式">
            <el-option label="自动打款" value="1"></el-option>
            <el-option label="手动打款" value="2"></el-option>
            <el-option label="暂缓打款" value="3"></el-option>
            <el-option label="提现回退" value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注: ">
          <el-input type="textarea" v-model="withdrawForm.remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="submitWithdraw">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="设置提现规则" :visible.sync="setRuleDialogVisible" width="35%">
      <el-form ref="setRuleRef" :model="setRuleForm" :rules="setRuleRules" label-width="160px">
        <el-form-item label="单笔最低" prop="minAmount">
          <el-input v-model="setRuleForm.minAmount"></el-input>
        </el-form-item>
        <el-form-item label="单笔最高" prop="maxAmount">
          <el-input v-model="setRuleForm.maxAmount"></el-input>
        </el-form-item>
        <el-form-item label="单日最高" prop="totalAmount">
          <el-input v-model="setRuleForm.totalAmount"></el-input>
        </el-form-item>
        <el-form-item label="单笔手续费(千分比)" prop="serviceFeeRate">
          <el-input v-model="setRuleForm.serviceFeeRate"></el-input>
        </el-form-item>
        <el-form-item label="单笔手续费(每笔元)" prop="serviceFeeUnit">
          <el-input v-model="setRuleForm.serviceFeeUnit"></el-input>
        </el-form-item>
        <el-form-item label="手续费类型" prop="serviceFeeType">
          <el-select v-model="setRuleForm.serviceFeeType" size="medium" placeholder="请选择手续费类型">
            <el-option label="单笔手续费(千分比)" :value="1"></el-option>
            <el-option label="单笔手续费(每笔元)" :value="2"></el-option>
            <el-option label="单笔手续费(千分比 + 每笔元)" :value="3"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="addRule">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import { rule, list, withdraw, setRule, excel } from '@/API/withdraw'
export default {
  name: 'withdraw',
  data() {
    return {
      activeName: 'record',
      //   提现规则列表
      ruleList: [],
      ruleQuery: {
        curPage: 1,
        pageSize: 10
      },
      ruleTotal: 0,
      //   提现记录搜索数据
      recordQuery: {
        curPage: 1,
        pageSize: 10,
        cellphone: '',
        sourceType: '',
        accountType: ''
      },
      recordTotal: 0,
      //   提现记录时间段
      period: [],
      //   提现记录列表
      withdrawalList: [],
      // 处理提现对话框
      editDialogVisible: false,
      // 处理提现表单数据
      withdrawForm: {
        uuid: '',
        state: '',
        remark: ''
      },
      setRuleDialogVisible: false,
      setRuleForm: {
        minAmount: '',
        maxAmount: '',
        totalAmount: '',
        serviceFeeRate: '',
        serviceFeeUnit: '',
        serviceFeeType: ''
      },
      // 下发代理表单验证规则
      setRuleRules: {
        serviceFeeType: [{ required: true, message: '请选择规则类型', trigger: 'change' }],
        serviceFeeUnit: [{ required: true, message: '请输入单笔手续费(%)', trigger: 'blur' }],
        serviceFeeRate: [{ required: true, message: '请输入单笔手续费(元)', trigger: 'blur' }],
        minAmount: [{ required: true, message: '请输入单笔最低', trigger: 'blur' }],
        maxAmount: [{ required: true, message: '请输入单笔最高', trigger: 'blur' }],
        totalAmount: [{ required: true, message: '请输入当日最高', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.getRule()
  },
  methods: {
    //   获取提现规则
    async getRule() {
      const { data: res } = await rule(this.ruleQuery)
      if (res.code !== 200) return this.$message.error(res.message)
      this.ruleList = res.data.entities
      this.ruleTotal = res.data.totalSize
    },
    // 提现规则监听pageSize
    rulePageSizeChange(newSize) {
      this.ruleQuery.pageSize = newSize
      this.getRule()
    },
    // 提现规则监听curPage
    ruleCurrentPageChange(newPage) {
      this.ruleQuery.curPage = newPage
      this.getRule()
    },
    // 获取提现记录列表数据
    async getRecord() {
      const { data: res } = await list(this.recordQuery)
      if (res.code !== 200) return this.$message.error(res.message)
      this.withdrawalList = res.data.entities
      this.recordTotal = res.data.totalSize
    },
    // 搜索按钮点击事件
    seach() {
      if (this.recordQuery.sourceType === '') return this.$message.info('请选择要查询的用户类型')
      this.recordQuery.curPage = 1
      if (this.period != null && this.period.length > 0) {
        this.recordQuery.ctStart = this.period[0]
        this.recordQuery.ctEnd = this.period[1]
      } else {
        this.recordQuery.ctStart = ''
        this.recordQuery.ctEnd = ''
      }
      this.getRecord()
    },
    // 提现记录列表监听pageSize
    recordPageSizeChange(newSize) {
      this.recordQuery.pageSize = newSize
      this.getRecord()
    },
    // 提现记录列表监听curPage
    recordCurrentPageChange(newPage) {
      this.recordQuery.curPage = newPage
      this.getRecord()
    },
    // 处理提现
    editWithdraw(uuid, remark) {
      this.withdrawForm.uuid = uuid
      this.editDialogVisible = true
      this.withdrawForm.remark = remark
    },
    // 提交提现处理
    async submitWithdraw() {
      if (this.withdrawForm.state === '') return this.$message.info('请选择提现状态')
      const { data: res } = await withdraw(this.withdrawForm)
      if (res.code !== 200) return this.$message.error(res.message)
      this.$message.success(res.message)
      this.getRecord()
      this.editDialogVisible = false
      this.withdrawForm = { uuid: '', state: '', remark: '' }
    },
    // 取消处理提现对话框
    cancel() {
      this.editDialogVisible = false
      this.withdrawForm = { uuid: '', state: '', remark: '' }
    },
    addRule() {
      this.$refs.setRuleRef.validate(async valid => {
        if (!valid) return
        const { data: res } = await setRule(this.setRuleForm)
        if (res.code !== 200) return this.$message.error(res.message)
        this.$message.success(res.message)
        this.$refs.setRuleRef.resetFields()
        this.setRuleDialogVisible = false
        this.getRule()
      })
    },
    cancelAdd() {
      this.$refs.setRuleRef.resetFields()
      this.setRuleDialogVisible = false
    },
    async downloadExcel() {
      if (this.recordQuery.sourceType === '') return this.$message.info('请选择要查询的用户类型')
      this.recordQuery.curPage = 1
      if (this.period != null && this.period.length > 0) {
        this.recordQuery.ctStart = this.period[0]
        this.recordQuery.ctEnd = this.period[1]
      } else {
        this.recordQuery.ctStart = ''
        this.recordQuery.ctEnd = ''
      }
      const { data: res } = await excel(this.recordQuery).catch(err => {
        if (err.response) {
          if (err.response.status === 701) {
            return this.$message.error('请筛选后再导出')
          } else if (err.response.status === 702) {
            return this.$message.error('无筛选记录')
          }
        }
        return this.$message.error('系统繁忙，请稍候再试')
      })
      if (!res) {
        return
      }
      let blob = new Blob([res], { type: 'application/vnd.ms-excel' })
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = URL.createObjectURL(blob)
      link.setAttribute('download', '提现列表-' + new Date().getTime() + '.xlsx')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}
</script>

<style lang="less" scoped>
.el-pagination {
  margin-top: 30px;
}
.searchBtn {
  margin-left: 50px;
}
.el-card__body {
  padding: 0;
  .el-form-item {
    margin: 0;
    margin: 0;
    width: 33%;
  }
  .uuidBox {
    position: relative;
    cursor: pointer;
  }
  .el-pagination {
    padding-top: 20px;
  }
}
.text {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all
}
</style>
